/* istanbul ignore file */
export * from './OocvTable';
